import { StorageService } from "./storage.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { Uris } from "./Uris";

@Injectable({
  providedIn: "root"
})
export class DietService {
  constructor(
    public storageService: StorageService,
    private http: HttpClient,
    public router: Router
  ) {}

  getDiets(query) {
    return this.http.get(`${Uris.DIET}${query}`, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getDiet(id) {
    return this.http.get(`${Uris.DIET}${id}/`, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  /**
   * Registra una dieta.
   * @param value - Datos de la dieta.
   * @param silent - true para omitir el mensaje de exito, en procesos automaticos.
   * @returns Observable con la dieta creada.
   */
  postDiet(value, silent = false) {
    return this.http.post(`${Uris.DIET}`, value, this.storageService.headers()).pipe(
      map((resp: any) => {
        if (!silent) {
          this.storageService.animation("success", "Éxito", `Dieta registrada correctamente`);
        }
        return resp;
      })
    );
  }

  /**
   * Edita una dieta existente.
   * @param id - Id de la dieta.
   * @param value - Datos completos de la dieta.
   * @param silent - true para omitir el mensaje de exito, en procesos automaticos.
   * @returns Observable con la dieta editada.
   */
  patchDiet(id, value, silent = false) {
    return this.http.put(`${Uris.DIET}${id}/`, value, this.storageService.headers()).pipe(
      map((resp: any) => {
        if (!silent) {
          this.storageService.animation("success", "Éxito", `Dieta editada correctamente`);
        }
        return resp;
      })
    );
  }

  deleteDiet(id) {
    return this.http.delete(`${Uris.DIET}${id}/`, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation("success", "Éxito", `Dieta eliminada correctamente`);
        return resp;
      })
    );
  }
}
